import React, { useEffect, useRef, useState } from 'react';
import * as Yup from "yup";
import Switch from "react-bootstrap-switch";
import {useForm} from "react-hook-form";
import {connect, useSelector} from "react-redux";
import {
    Button, Card, CardBody, CardTitle, Col, Form, FormGroup,
    Input, InputGroup, InputGroupAddon, Label, Row
} from 'reactstrap';
import {getStateByPath} from "../../../redux/selectors";


// components
import ServicesLangs from "./_langs";
import SelectGeneric from "../../../components/select/selectGeneric";
import {showToastCustom} from "../../../components/toast/customToast";
import {LogHistoryModal} from "../../../components/logHistory/logHistoryModal";
import {MapPickerModal} from "../../../components/map/MapPickerModal";
import {GenericButton} from "../../../components/buttons/customButtons";
import Separator from "../../../components/Separator";
import TranslateButton from "../../../components/buttons/TranslateButton";
import {ConfirmDelete} from "../../../components/confirmAlert/ConfirmDelete";

// labels
import {error, FORM, INTERNATIONAL, LB_ACTIVE, LB_EVENT, selectOption} from "../../../components/i18n/i18n";
import {TT_CLOSE, TT_DELETE, TT_HISTORY, TT_SAVE} from "../../../components/i18n/toolTips";

// services & providers
import {routProvider} from "../../../providers/routProvider";
import {categoryProvider} from "../../../providers/categoryProvider";
import {typeServicesProvider} from "../../../providers/typeServicesProvider";
import {serviceLocationService} from "../../../jwt/_services/clasificator/serviceLocationService";

// actions
import {genericIndexedActions} from "../../../redux/actions/generics/GenericIndexedActions";
import {setForm, setItem} from "../../../redux/actions/generics/IndexedActions";

// components
// labels
// actions
// services & providers


function ServicesForm(props) {
    // const { editMode, domainObject } = props.formProps;
    // const { udn, mapConfig } = props.mainProps;
    // const fbDataBaseId = props.mainProps?.app?.fbDataBase?.id

    const componentState = useSelector(state => getStateByPath(state, props.path));

    const { path } = componentState;
    const { app, udn, editMode, domainObject, mapConfig } = componentState?.data;


    const [langs, setLangs] = useState(domainObject?.langs || []);
    const translatableLangs = domainObject?.translatedLangs || []

    const [schedule24, setSchedule24] = useState(domainObject?.schedule24 || '');
    const [schedule12, setSchedule12] = useState(domainObject?.schedule12 || '');

    const [timeFrom, setTimeFrom] = useState('00:00');
    const [timeTo, setTimeTo] = useState('00:00');

    const requiredCategory = app?.code !== 'EVENTS'
    const requiredServiceType = app?.code !== 'EVENTS'

    const [status, setStatus] = useState(domainObject?.status || false);
    const [aditionalCost, setAditionalCost] = useState(domainObject?.aditionalCost || false);
    const [weatherConditions, setWeatherConditions] = useState(domainObject?.weatherConditions || false);
    const [routeId, setRouteId] = useState( domainObject?.rout?.id || null);
    const [categoryId, setCategoryId] = useState( domainObject?.category?.id || null);
    const [typeServiceId, setTypeServiceId] = useState( domainObject?.services?.id || null);

    const [showModalHistory, setShowModalHistory] = useState(true)
    const [showMapModal, setShowMapModal] = useState(true);
    const modalHistoryRef = useRef(null);
    const modalMapRef = useRef(null);

    const [position, setPosition] = useState(editMode ? {
        lat: parseFloat(domainObject?.latitude),
        lng: parseFloat(domainObject?.longitude)
    } : mapConfig?.center);

    const showHistory = () => {
        setShowModalHistory(true);
        modalHistoryRef.current.showModal();
    }

    const showMap = () => {
        setShowMapModal(true);
        modalMapRef.current.showModal(mapConfig);
    }

    const validationSchema = Yup.object().shape({});
    console.log(domainObject?.schedule24.split("-")[0])

    const {register, handleSubmit, reset } = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            id: domainObject?.id,
            uid: domainObject?.uid,

            latitude: domainObject?.latitude,
            longitude: domainObject?.longitude,
            schedule12: domainObject?.schedule12,
            schedule24: domainObject?.schedule24,
            icon: domainObject?.icon,
            photo: domainObject?.photo,
            anden: domainObject?.anden,
            color: domainObject?.color,
            departures: domainObject?.departures
        }
    });

    useEffect(() => {
        if (domainObject?.schedule24) {
            const splited = domainObject?.schedule24.split("-");
            if (splited.length === 2) {
                setTimeFrom(splited[0].trim())
                setTimeTo(splited[1].trim())
            }
        }
    }, [domainObject?.schedule24])

    const setSchedule = (from, to) => {
        const fromh24 = from.split(':')[0];
        const fromm24 = from.split(':')[1];

        let toh24 = to.split(':')[0];
        let tom24 = to.split(':')[1];

        if (fromh24 > toh24 || (fromh24 === toh24 && fromm24 > tom24)) {
            to = from;

            toh24 = to.split(':')[0];
            tom24 = to.split(':')[1];
            setTimeTo(to);
        }

        let from12;
        let to12;

        if (fromh24 >= 12) {
            from12 = fromh24 === "12" ? `12:${fromm24} PM` : `${fromh24 - 12}:${fromm24} PM`;
        } else {
            from12 = `${fromh24}:${fromm24} AM`;
        }

        if (toh24 >= 12) {
            to12 = toh24 === "12" ? `12:${tom24} PM` : `${toh24 - 12}:${tom24} PM`;
        } else {
            to12 = `${toh24}:${tom24} AM`;
        }

        if (from === to) {
            setSchedule24(`${from}`);
            setSchedule12(`${from12}`);
        } else {
            setSchedule24(`${from} - ${to}`);
            setSchedule12(`${from12} - ${to12}`);
        }
    }

    // ----------------------------------------------
    //            CHANGE HANDLERS
    // ----------------------------------------------
    const onTimeFromChange = (value) => {
        setTimeFrom(value);
        setSchedule(value, timeTo);
    }

    const onTimeToChange = (value) => {
        setTimeTo(value);
        setSchedule(timeFrom, value);
    }

    const onLatChange = (value ) => {
        setPosition({
            ...position,
            lat : value
        })
    }

    const onLngChange = ( value ) => {
        setPosition({
            ...position,
            lng : value
        })
    }

    // ----------------------------------------------
    //            SUBMIT
    // ----------------------------------------------

    const onSubmit = (data, _) => {
        if(requiredCategory && !categoryId)
            return showToastCustom(error, selectOption);

        if (requiredServiceType && !typeServiceId)
            return showToastCustom(error, selectOption);

        let dataRequest = {
            fbDataBase :  { id : app?.fbDataBase?.id },
            item : {
                ...data,
                id: domainObject?.id,
                uid: domainObject?.uid,
                latitude: position.lat,
                longitude: position.lng,
                schedule12: schedule12,
                schedule24: schedule24,

                status: status,
                aditionalCost: aditionalCost,
                weatherConditions: weatherConditions,

                udn: udn,
                services : { id : typeServiceId },
                rout : { id : routeId },
                category : { id : categoryId },
                langs: langs,
                
                openingTime: timeFrom,
                closingTime: timeTo,
            }
        };

        if (editMode) {
            let id = domainObject.id;
            dataRequest.item.id = id

            genericIndexedActions.update(path, serviceLocationService, id, dataRequest)
        } else {
            genericIndexedActions.save(path, serviceLocationService, dataRequest)
        }

        returnToList()
    };

    const confirmDelete = (data) => {
        return ConfirmDelete({
            path,
            remove : genericIndexedActions.delete,
            data : data,
            fbDataBaseId :  app?.fbDataBase?.id,
            service: serviceLocationService
        } );
    };

    const returnToList = () => {
        reset();
        props.setItem(path, null);
        props.setForm(path, false, false, false);
        props.onClose();
    }


    return (<>
        <Form onSubmit={handleSubmit(onSubmit)}>
            <Card className={'card-modal-medium'}>
                <CardTitle className="bg-light border-bottom p-3 mb-0">
                    {
                        editMode ?  <>
                                <h2 className={'card-modal-title'} > { app.name + '  /  ' + udn.value + ' / ' + ' Servicios / ' + domainObject?.name?.toUpperCase() }</h2>
                                <br />
                                <h5 className={'card-modal-uid'} > { '     uid: ' + domainObject?.uid || '' }</h5>
                            </> :
                            <>
                                <h2 className={'card-modal-title'} > { app.name + '  /  ' + udn.value + ' / ' + ' Servicios / Nuevo '  }</h2>
                                <br />
                                <h5 className={'card-modal-uid'} > {  }</h5>
                            </>
                    }
                    <div className="top-right">
                        <GenericButton
                            style={'table'}
                            icon={'fa-save'}
                            toolTip={TT_SAVE}
                            permission={'add'}
                            type={'submit'}
                        />
                        {
                            editMode &&
                            <>
                                <Separator/>
                                <GenericButton
                                    style={'table'}
                                    toolTip={TT_HISTORY}
                                    icon={'fa-clock'}
                                    permission={'search'}
                                    onClick={showHistory}
                                />
                                <TranslateButton item={domainObject} service={serviceLocationService} />
                                <GenericButton
                                    style={'danger-secondary'}
                                    toolTip={TT_DELETE}
                                    icon={'fa-trash'}
                                    permission={'delete'}
                                    onClick={_ => confirmDelete(domainObject)}
                                />
                            </>
                        }
                        <Separator/>
                        <GenericButton
                            style={'danger-secondary'}
                            toolTip={TT_CLOSE}
                            icon={'fa-times'}
                            permission={'search'}
                            onClick={returnToList}
                        />
                    </div>
                </CardTitle>
                <CardBody className={'card-body-modal'}>
                    <Row>
                        <Col md="4">
                            <FormGroup>
                                <Label>Tipo de Servicio</Label>
                                <SelectGeneric
                                    initialValue={typeServiceId}
                                    setExternalValue={setTypeServiceId}
                                    provider={typeServicesProvider}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="4">
                            <FormGroup>
                                <Label>Categoria</Label>
                                <SelectGeneric
                                    initialValue={categoryId}
                                    setExternalValue={setCategoryId}
                                    provider={categoryProvider}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="4">
                            <FormGroup>
                                <Label>Ruta</Label>
                                <SelectGeneric
                                    initialValue={routeId}
                                    setExternalValue={setRouteId}
                                    provider={routProvider}
                                />
                            </FormGroup>
                        </Col>

                    </Row>
                    <Row>
                        <Col md="6">
                            <FormGroup>
                                <Label>Latitud y longitud</Label>
                                <InputGroup>
                                    <Button color=" background-color-primary" onClick={showMap}>
                                        <i className="fas fa-map-marker-alt text-white"/>
                                    </Button>
                                    <InputGroupAddon addonType="append">
                                        <Input type="number"
                                               name="lat"
                                               value={position?.lat}
                                               className={'lat-lng-input'}
                                               step={'0.0000001'}
                                               onChange={e => onLatChange(e.target.value)}
                                        />
                                    </InputGroupAddon>
                                    <InputGroupAddon addonType="append">
                                        <Input type="number"
                                               name="lng"
                                               className={'lat-lng-input'}
                                               value={position?.lng}
                                               step={'0.0000001'}
                                               onChange={e => onLngChange(e.target.value)}
                                        />
                                    </InputGroupAddon>
                                </InputGroup>
                            </FormGroup>
                        </Col>
                        <Col md="2">
                            <FormGroup>
                                <Label>Activo</Label>
                                <br/>
                                <Switch animate={true}
                                        offText={"No"}
                                        onText={"Si"}
                                        value={status}
                                        onChange={_ => setStatus(!status)}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="2">
                            <FormGroup>
                                <Label>Costo adicional</Label>
                                <br/>
                                <Switch animate={true}
                                        offText={"No"}
                                        onText={"Si"}
                                        value={aditionalCost}
                                        onChange={_ => setAditionalCost(!aditionalCost)}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="2">
                            <FormGroup>
                                <Label>Depende del clima</Label>
                                <br/>
                                <Switch animate={true}
                                        offText={"No"}
                                        onText={"Si"}
                                        value={weatherConditions}
                                        onChange={_ => setWeatherConditions(!weatherConditions)}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="4">
                            <FormGroup>
                                <Label>{'Imagen'}</Label>
                                <Input type="text"
                                       name="photo"
                                       placeholder="Ingrese nombre"
                                       innerRef={register}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="4">
                            <FormGroup>
                                <Label>{'Icono'}</Label>
                                <Input type="text"
                                       name="icon"
                                       placeholder="Ingrese nombre"
                                       innerRef={register}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="2">
                            <FormGroup>
                                <Label>Desde</Label>
                                <Input type="time"
                                       name="timeFrom"
                                       placeholder="Ingrese hora"
                                       innerRef={register}
                                       value={timeFrom}
                                       onChange={e => onTimeFromChange(e.target.value)}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="2">
                            <FormGroup>
                                <Label>Hasta</Label>
                                <Input type="time" name="timeTo"
                                       placeholder="Ingrese hora"
                                       innerRef={register}
                                       value={timeTo}
                                       onChange={e => onTimeToChange(e.target.value)}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <div className={'form-container'}>
                        <div className={''}>
                            <h2>{INTERNATIONAL}</h2>
                        </div>
                        <div className={''}>
                            <Row>
                                <Col md="12">
                                    <ServicesLangs
                                        langs={langs}
                                        setLangs={setLangs}
                                        translatableLangs={translatableLangs}
                                    />
                                </Col>
                            </Row>
                        </div>
                    </div>
                </CardBody>
            </Card>
        </Form>
        {
            showMapModal && <MapPickerModal
                ref={modalMapRef}
                setPosition={setPosition}
                initialPosition={position}
                googleConfig={mapConfig}
                updateMarkerPosition={true}
            />
        }
        {
            showModalHistory && <LogHistoryModal
                ref={ modalHistoryRef }
                item={ domainObject }
            />
        }
    </>)
}

const mapStateToProps = state => ({
})

const mapActionsToProps = ({
    setItem,
    setForm,
})

export default connect(mapStateToProps, mapActionsToProps)(ServicesForm)